import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import { QueryClientProvider } from "@tanstack/solid-query";
import { createQueryClient } from "@core/query/createQueryClient";
import { AuthProvider } from "@core/auth/session";
import { AppShell } from "@ui/layout/AppShell";
import { LoginScreen } from "@app/LoginScreen";
import { ChatListView } from "@modules/chats/components/ChatListView";
import { BookingListView } from "@modules/bookings/components/BookingListView";
import { PaymentListView } from "@modules/payments/components/PaymentListView";
import { LocationListView } from "@modules/locations/components/LocationListView";
import { RobotListView } from "@modules/robots/components/RobotListView";
import { UserListView } from "@modules/users/components/UserListView";
import { NotificationsView } from "@modules/notifications/components/NotificationsView";
import { SettingsMain } from "@modules/settings/components/SettingsMain";
import { DashboardView } from "@app/DashboardView";
import "@styles/global.css";

const queryClient = createQueryClient();

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

render(
  () => (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Route path="/" component={AppShell}>
            <Route path="/" component={DashboardView} />
            <Route path="/bookings" component={BookingListView} />
            <Route path="/locations" component={LocationListView} />
            <Route path="/robots" component={RobotListView} />
            <Route path="/users" component={UserListView} />
            <Route path="/chats" component={ChatListView} />
            <Route path="/settings" component={SettingsMain} />
            <Route path="/notifications" component={NotificationsView} />
          </Route>
          <Route path="/login" component={LoginScreen} />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  ),
  root,
);
